<template>
  <b-modal
    size="xl"
    centered
    no-close-on-backdrop
    ok-title="Enviar"
    id="modal-version-management"
    modal
    title="Gerencimento de Versões"
  >
    <div>
      <!-- MENU SUPERIOR -->
      <b-nav tabs>
        <b-nav-item :active="menuItem === 'name'" @click="menuItem = 'name'"
          >Nome</b-nav-item
        >
        <b-nav-item
          :active="menuItem === 'description'"
          @click="menuItem = 'description'"
          >Descrição</b-nav-item
        >
        <b-nav-item :active="menuItem === 'policy'" @click="menuItem = 'policy'"
          >Política</b-nav-item
        >
        <b-nav-item
          :active="menuItem === 'scope'"
          @click="menuItem = 'scope'"
          >{{ this.$ml.get("scope") }}</b-nav-item
        >
        <b-nav-item
          :active="menuItem === 'rewards'"
          @click="menuItem = 'rewards'"
          >Recompensas</b-nav-item
        >
        <b-nav-item
          :active="menuItem === 'otherRewards'"
          @click="menuItem = 'otherRewards'"
          >Outras Recompensas</b-nav-item
        >
      </b-nav>

      <div class="container-version-manager" style="position: relative">
        <div
          class="d-flex justify-content-between align-items-center"
          style="gap: 10px; flex-wrap: wrap"
        >
          <div class="d-flex align-items-center" style="gap: 10px">
            <span
              >Versão antiga:
              <strong style="font-weight: 400">
                {{ $utils.formatDataShort(versions_program_old.createdAt) }}
              </strong>
              {{ $ml.get("toThe") }}
              <strong style="font-weight: 400">{{
                $utils.formatTimeOnly(versions_program_old.createdAt)
              }}</strong></span
            >
            <svg width="16" height="16">
              <image
                xlink:href="../../assets/icons/version-fill.svg"
                width="16"
                height="16"
              />
            </svg>
            <span
              >Versão atual:
              <strong style="font-weight: 400">
                {{ $utils.formatDataShort(versions_program_current.createdAt) }}
              </strong>
              {{ $ml.get("toThe") }}
              <strong style="font-weight: 400">{{
                $utils.formatTimeOnly(versions_program_current.createdAt)
              }}</strong></span
            >
          </div>

          <div class="d-flex align-items-center" style="gap: 20px">
            <span
              v-text="$ml.get('btnPrev')"
              class="next-control"
              @click="currentStep > 0 && currentStep--"
              >Anterior</span
            >
            <span
              class="next-control"
              @click="
                currentStep < filterListProgramUpdates?.length - 1 &&
                  currentStep++
              "
              v-text="$ml.get('btnNext')"
              >Próximo</span
            >
          </div>
        </div>
        <div class="mt-3">
          <div
            v-if="
              menuItem === 'name' ||
              menuItem === 'description' ||
              menuItem === 'policy'
            "
          >
            <CodeDiff
              v-show="menuItem === 'name'"
              :old-string="versions_program_old?.name"
              :new-string="versions_program_current?.name"
              diff-style="word"
              output-format="side-by-side"
              aria-label="teste"
            />
            <CodeDiff
              v-show="menuItem === 'description'"
              :old-string="versions_program_old?.description"
              :new-string="versions_program_current?.description"
              diff-style="word"
            />
            <CodeDiff
              v-show="menuItem === 'policy'"
              :old-string="versions_program_old?.policy"
              :new-string="versions_program_current?.policy"
              diff-style="word"
            />
          </div>
          <!-- ESCOPO -->
          <div
            v-if="menuItem === 'scope'"
            class="d-flex justify-content-between"
            style="gap: 10px"
          >
            <!-- ESCOPO - VERSÃO ANTIGA -->
            <div class="card card-body p-0 d-flex col">
              <table>
                <thead v-if="versions_program_old.scope">
                  <tr>
                    <th class="col-9" v-text="$ml.get('scope')">Escopo</th>
                    <th class="col-8 pl-0" v-text="$ml.get('type')">Tipo</th>
                    <th
                      class="col-4 pl-0 text-truncate"
                      v-text="$ml.get('severity')"
                    >
                      Severidade
                    </th>
                    <th class="col-3 pl-0 text-truncate">Bounty</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-if="
                      !versions_program_old.scope ||
                      !versions_program_old.scope?.length
                    "
                    class="d-flex align-items-center justify-content-center"
                  >
                    <h6 class="my-3" v-text="$ml.get('noScopeAvailable')">
                      Nenhum escopo disponível!
                    </h6>
                  </tr>
                  <tr
                    v-else
                    v-for="(item, index) in versions_program_old.scope"
                    :key="index"
                    v-show="item.status != 'inactive'"
                    :class="{
                      removeScope: !versions_program_current.scope.find(
                        (c) => c.description === item.description
                      ),
                    }"
                  >
                    <td class="col-9">
                      <strong><a v-text="item.description"></a></strong>
                    </td>
                    <td class="col-8 pl-0 text-muted">
                      <span
                        :class="
                          (() => {
                            const currentItem =
                              versions_program_current.scope.find(
                                (o) => o.description === item.description
                              );
                            return currentItem && currentItem.type !== item.type
                              ? ['removeScope', 'text-center']
                              : [];
                          })()
                        "
                        >{{ nameLang(item.type) }}</span
                      >
                    </td>
                    <td class="col-4 pl-0">
                      <div
                        :class="
                          (() => {
                            const currentItem =
                              versions_program_current.scope.find(
                                (o) => o.description === item.description
                              );
                            return currentItem &&
                              currentItem.severity !== item.severity
                              ? [
                                  'removeScope',
                                  'd-flex',
                                  'justify-content-center',
                                ]
                              : ['d-flex', 'justify-content-center'];
                          })()
                        "
                      >
                        <Impact
                          class="d-flex mt-1"
                          :impact="'impact-' + item.severity"
                        />
                      </div>
                    </td>
                    <td class="col-3 pl-0">
                      <div
                        :class="
                          (() => {
                            const currentItem =
                              versions_program_current.scope.find(
                                (o) => o.description === item.description
                              );
                            return currentItem &&
                              currentItem.offers_bounty !== item.offers_bounty
                              ? ['removeScope', 'text-center']
                              : ['text-center'];
                          })()
                        "
                      >
                        <VueCustomTooltip
                          :label="$ml.get('eligible')"
                          v-if="item.offers_bounty"
                          class="row"
                        >
                          <img
                            class="img-money"
                            src="../../assets/images/money.png"
                          />
                        </VueCustomTooltip>
                        <VueCustomTooltip
                          :label="$ml.get('notEligible')"
                          v-if="!item.offers_bounty"
                          class="row"
                        >
                          <img
                            class="img-money"
                            src="../../assets/images/no-money.png"
                          />
                        </VueCustomTooltip>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- ESCOPO - VERSÃO ATUAL -->
            <div class="card card-body p-0 d-flex col">
              <table>
                <thead v-if="versions_program_current">
                  <tr>
                    <th class="col-9" v-text="$ml.get('scope')">Escopo</th>
                    <th class="col-8 pl-0" v-text="$ml.get('type')">Tipo</th>
                    <th
                      class="col-4 pl-0 text-truncate"
                      v-text="$ml.get('severity')"
                    >
                      Severidade
                    </th>
                    <th class="col-3 pl-0 text-truncate">Bounty</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-if="
                      !versions_program_current.scope ||
                      !versions_program_current.scope?.length
                    "
                    class="d-flex align-items-center justify-content-center"
                  >
                    <h6 class="my-3" v-text="$ml.get('noScopeAvailable')">
                      Nenhum escopo disponível!
                    </h6>
                  </tr>
                  <tr
                    v-else
                    v-for="(item, index) in versions_program_current.scope"
                    style="position: relative"
                    :key="index"
                    :class="{
                      addScope: !versions_program_old.scope.some(
                        (old) => old.description === item.description
                      ),
                      removeScope: item.status === 'inactive',
                    }"
                  >
                    <td class="col-9">
                      <strong><a v-text="item.description"></a></strong>
                    </td>
                    <td class="col-8 pl-0 text-muted">
                      <span
                        :class="{
                          addScope: (() => {
                            const oldItem = versions_program_old.scope.find(
                              (o) => o.description === item.description
                            );
                            return oldItem && oldItem.type !== item.type;
                          })(),
                        }"
                        >{{ nameLang(item.type) }}</span
                      >
                    </td>
                    <td class="col-4 pl-0">
                      <div
                        :class="
                          (() => {
                            const oldItem = versions_program_old.scope.find(
                              (o) => o.description === item.description
                            );
                            return oldItem && oldItem.severity !== item.severity
                              ? ['addScope', 'd-flex', 'justify-content-center']
                              : ['d-flex', 'justify-content-center'];
                          })()
                        "
                      >
                        <Impact
                          class="d-flex mt-1"
                          :impact="'impact-' + item.severity"
                        />
                      </div>
                    </td>
                    <td class="col-3 pl-0">
                      <div
                        :class="
                          (() => {
                            const oldItem = versions_program_old.scope.find(
                              (o) => o.description === item.description
                            );
                            return oldItem &&
                              oldItem.offers_bounty !== item.offers_bounty
                              ? ['addScope', 'text-center']
                              : ['text-center'];
                          })()
                        "
                      >
                        <VueCustomTooltip
                          :label="$ml.get('eligible')"
                          v-if="item.offers_bounty"
                          class="row"
                        >
                          <img
                            class="img-money"
                            src="../../assets/images/money.png"
                          />
                        </VueCustomTooltip>
                        <VueCustomTooltip
                          :label="$ml.get('notEligible')"
                          v-if="!item.offers_bounty"
                          class="row"
                        >
                          <img
                            class="img-money"
                            src="../../assets/images/no-money.png"
                          />
                        </VueCustomTooltip>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- RECOMPENSAS -->
          <div
            v-if="menuItem === 'rewards'"
            class="d-flex justify-content-between"
            style="gap: 10px"
          >
            <!-- RECOMPENSAS - VERSÃO ANTIGA -->
            <div class="card card-body p-0 d-flex col">
              <table>
                <thead>
                  <tr>
                    <th
                      :class="['pl-3', 'pl-0', 'col']"
                      v-text="$ml.get('severity')"
                    >
                      Severidade
                    </th>
                    <th :class="['pl-0', 'col']" v-text="$ml.get('reward')">
                      Recompensa
                    </th>
                    <th
                      v-if="
                        versions_program_old?.active_campaign &&
                        versions_program_old?.offers_double_bounty
                      "
                      class="col-8 pl-0"
                      v-text="$ml.get('doubleReward')"
                    >
                      Recompensa em dobro
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    :class="{
                      removeScope:
                        versions_program_old?.bounty_low !=
                          versions_program_current?.bounty_low ||
                        versions_program_old?.active_campaign !=
                          versions_program_current?.active_campaign,
                    }"
                  >
                    <td
                      :class="['row', 'd-flex', 'align-content-center', 'col']"
                    >
                      <Impact impact="impact-low" class="mt-1" />
                      <strong class="mx-2" v-text="$ml.get('low')"
                        >Baixo</strong
                      >
                    </td>
                    <td :class="['pl-0', 'text-muted', 'col']">
                      <div class="form-control" v-if="this.isDollar === 'BRL'">
                        {{
                          $utils.convertMoney(versions_program_old.bounty_low)
                        }}
                      </div>
                      <div class="form-control" v-else>
                        {{
                          $utils.convertDollar(versions_program_old.bounty_low)
                        }}
                      </div>
                    </td>
                    <td
                      v-if="
                        versions_program_old?.active_campaign &&
                        versions_program_old?.offers_double_bounty
                      "
                      class="w-100 pl-0 text-muted"
                    >
                      <div class="form-control" v-if="this.isDollar === 'BRL'">
                        {{
                          $utils.convertMoney(
                            versions_program_old.bounty_low_double
                          )
                        }}
                      </div>
                      <div class="form-control" v-else>
                        {{
                          $utils.convertDollar(
                            versions_program_old.bounty_low_double
                          )
                        }}
                      </div>
                    </td>
                  </tr>
                  <tr
                    :class="{
                      removeScope:
                        versions_program_old?.bounty_medium !=
                          versions_program_current?.bounty_medium ||
                        versions_program_old?.active_campaign !=
                          versions_program_current?.active_campaign,
                    }"
                  >
                    <td
                      :class="['row', 'd-flex', 'align-content-center', 'col']"
                    >
                      <Impact impact="impact-medium" class="mt-1" />
                      <strong class="mx-2" v-text="$ml.get('medium')"
                        >Médio</strong
                      >
                    </td>
                    <td :class="['pl-0', 'text-muted', 'col']">
                      <div class="form-control" v-if="this.isDollar === 'BRL'">
                        {{
                          $utils.convertMoney(
                            versions_program_old.bounty_medium
                          )
                        }}
                      </div>
                      <div class="form-control" v-else>
                        {{
                          $utils.convertDollar(
                            versions_program_old.bounty_medium
                          )
                        }}
                      </div>
                    </td>
                    <td
                      v-if="
                        versions_program_old?.active_campaign &&
                        versions_program_old?.offers_double_bounty
                      "
                      class="col-lg-8 w-100 pl-0 text-muted"
                    >
                      <div class="form-control" v-if="this.isDollar === 'BRL'">
                        {{
                          $utils.convertMoney(
                            versions_program_old.bounty_medium_double
                          )
                        }}
                      </div>
                      <div class="form-control" v-else>
                        {{
                          $utils.convertDollar(
                            versions_program_old.bounty_medium_double
                          )
                        }}
                      </div>
                    </td>
                  </tr>
                  <tr
                    :class="{
                      removeScope:
                        versions_program_old?.bounty_high !=
                          versions_program_current?.bounty_high ||
                        versions_program_old?.active_campaign !=
                          versions_program_current?.active_campaign,
                    }"
                  >
                    <td
                      :class="['row', 'd-flex', 'align-content-center', 'col']"
                    >
                      <Impact impact="impact-high" class="mt-1" />
                      <strong class="mx-2" v-text="$ml.get('high')"
                        >Alto</strong
                      >
                    </td>
                    <td :class="['pl-0', 'text-muted', 'col']">
                      <div class="form-control" v-if="this.isDollar === 'BRL'">
                        {{
                          $utils.convertMoney(versions_program_old.bounty_high)
                        }}
                      </div>
                      <div class="form-control" v-else>
                        {{
                          $utils.convertDollar(versions_program_old.bounty_high)
                        }}
                      </div>
                    </td>
                    <td
                      v-if="
                        versions_program_old?.active_campaign &&
                        versions_program_old?.offers_double_bounty
                      "
                      class="col-lg-8 w-100 pl-0 text-muted"
                    >
                      <div class="form-control" v-if="this.isDollar === 'BRL'">
                        {{
                          $utils.convertMoney(
                            versions_program_old.bounty_high_double
                          )
                        }}
                      </div>
                      <div class="form-control" v-else>
                        {{
                          $utils.convertDollar(
                            versions_program_old.bounty_high_double
                          )
                        }}
                      </div>
                    </td>
                  </tr>
                  <tr
                    :class="{
                      removeScope:
                        versions_program_old?.bounty_critical !=
                          versions_program_current?.bounty_critical ||
                        versions_program_old?.active_campaign !=
                          versions_program_current?.active_campaign,
                    }"
                  >
                    <td
                      :class="['row', 'd-flex', 'align-content-center', 'col']"
                    >
                      <Impact impact="impact-critical" class="mt-1" />
                      <strong class="mx-2" v-text="$ml.get('critical')"
                        >Crítico</strong
                      >
                    </td>
                    <td :class="['pl-0', 'text-muted', 'col']">
                      <div class="form-control" v-if="this.isDollar === 'BRL'">
                        {{
                          $utils.convertMoney(
                            versions_program_old.bounty_critical
                          )
                        }}
                      </div>
                      <div class="form-control" v-else>
                        {{
                          $utils.convertDollar(
                            versions_program_old.bounty_critical
                          )
                        }}
                      </div>
                    </td>
                    <td
                      v-if="
                        versions_program_old?.active_campaign &&
                        versions_program_old?.offers_double_bounty
                      "
                      class="col-lg-8 w-100 pl-0 text-muted"
                    >
                      <div class="form-control" v-if="this.isDollar === 'BRL'">
                        {{
                          $utils.convertMoney(
                            versions_program_old.bounty_critical_double
                          )
                        }}
                      </div>
                      <div class="form-control" v-else>
                        {{
                          $utils.convertDollar(
                            versions_program_old.bounty_critical_double
                          )
                        }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- RECOMPENSA - VERSÃO ATUAL -->

            <div class="card card-body p-0 d-flex col">
              <table>
                <thead>
                  <tr>
                    <th
                      :class="['pl-3', 'pl-0', 'col']"
                      v-text="$ml.get('severity')"
                    >
                      Severidade
                    </th>
                    <th :class="['pl-0', 'col']" v-text="$ml.get('reward')">
                      Recompensa
                    </th>
                    <th
                      v-if="
                        versions_program_current?.active_campaign &&
                        versions_program_current?.offers_double_bounty
                      "
                      class="col-8 pl-0"
                      v-text="$ml.get('doubleReward')"
                    >
                      Recompensa em dobro
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    :class="{
                      addScope:
                        versions_program_current?.bounty_low !=
                          versions_program_old?.bounty_low ||
                        versions_program_current?.active_campaign !=
                          versions_program_old?.active_campaign,
                    }"
                  >
                    <td
                      :class="['row', 'd-flex', 'align-content-center', 'col']"
                    >
                      <Impact impact="impact-low" class="mt-1" />
                      <strong class="mx-2" v-text="$ml.get('low')"
                        >Baixo</strong
                      >
                    </td>
                    <td :class="['pl-0', 'text-muted', 'col']">
                      <div class="form-control" v-if="this.isDollar === 'BRL'">
                        {{
                          $utils.convertMoney(
                            versions_program_current.bounty_low
                          )
                        }}
                      </div>
                      <div class="form-control" v-else>
                        {{
                          $utils.convertDollar(
                            versions_program_current.bounty_low
                          )
                        }}
                      </div>
                    </td>
                    <td
                      v-if="
                        versions_program_current?.active_campaign &&
                        versions_program_current?.offers_double_bounty
                      "
                      class="w-100 pl-0 text-muted"
                    >
                      <div class="form-control" v-if="this.isDollar === 'BRL'">
                        {{
                          $utils.convertMoney(
                            versions_program_current.bounty_low_double
                          )
                        }}
                      </div>
                      <div class="form-control" v-else>
                        {{
                          $utils.convertDollar(
                            versions_program_current.bounty_low_double
                          )
                        }}
                      </div>
                    </td>
                  </tr>
                  <tr
                    :class="{
                      addScope:
                        versions_program_current?.bounty_medium !=
                          versions_program_old?.bounty_medium ||
                        versions_program_current?.active_campaign !=
                          versions_program_old?.active_campaign,
                    }"
                  >
                    <td
                      :class="['row', 'd-flex', 'align-content-center', 'col']"
                    >
                      <Impact impact="impact-medium" class="mt-1" />
                      <strong class="mx-2" v-text="$ml.get('medium')"
                        >Médio</strong
                      >
                    </td>
                    <td :class="['pl-0', 'text-muted', 'col']">
                      <div class="form-control" v-if="this.isDollar === 'BRL'">
                        {{
                          $utils.convertMoney(
                            versions_program_current.bounty_medium
                          )
                        }}
                      </div>
                      <div class="form-control" v-else>
                        {{
                          $utils.convertDollar(
                            versions_program_current.bounty_medium
                          )
                        }}
                      </div>
                    </td>
                    <td
                      v-if="
                        versions_program_current?.active_campaign &&
                        versions_program_current?.offers_double_bounty
                      "
                      class="col-lg-8 w-100 pl-0 text-muted"
                    >
                      <div class="form-control" v-if="this.isDollar === 'BRL'">
                        {{
                          $utils.convertMoney(
                            versions_program_current.bounty_medium_double
                          )
                        }}
                      </div>
                      <div class="form-control" v-else>
                        {{
                          $utils.convertDollar(
                            versions_program_current.bounty_medium_double
                          )
                        }}
                      </div>
                    </td>
                  </tr>
                  <tr
                    :class="{
                      addScope:
                        versions_program_current?.bounty_high !=
                          versions_program_old?.bounty_high ||
                        versions_program_current?.active_campaign !=
                          versions_program_old?.active_campaign,
                    }"
                  >
                    <td
                      :class="['row', 'd-flex', 'align-content-center', 'col']"
                    >
                      <Impact impact="impact-high" class="mt-1" />
                      <strong class="mx-2" v-text="$ml.get('high')"
                        >Alto</strong
                      >
                    </td>
                    <td :class="['pl-0', 'text-muted', 'col']">
                      <div class="form-control" v-if="this.isDollar === 'BRL'">
                        {{
                          $utils.convertMoney(
                            versions_program_current.bounty_high
                          )
                        }}
                      </div>
                      <div class="form-control" v-else>
                        {{
                          $utils.convertDollar(
                            versions_program_current.bounty_high
                          )
                        }}
                      </div>
                    </td>
                    <td
                      v-if="
                        versions_program_current?.active_campaign &&
                        versions_program_current?.offers_double_bounty
                      "
                      class="col-lg-8 w-100 pl-0 text-muted"
                    >
                      <div class="form-control" v-if="this.isDollar === 'BRL'">
                        {{
                          $utils.convertMoney(
                            versions_program_current.bounty_high_double
                          )
                        }}
                      </div>
                      <div class="form-control" v-else>
                        {{
                          $utils.convertDollar(
                            versions_program_current.bounty_high_double
                          )
                        }}
                      </div>
                    </td>
                  </tr>
                  <tr
                    :class="{
                      addScope:
                        versions_program_current?.bounty_critical !=
                          versions_program_old?.bounty_critical ||
                        versions_program_current?.active_campaign !=
                          versions_program_old?.active_campaign,
                    }"
                  >
                    <td
                      :class="['row', 'd-flex', 'align-content-center', 'col']"
                    >
                      <Impact impact="impact-critical" class="mt-1" />
                      <strong class="mx-2" v-text="$ml.get('critical')"
                        >Crítico</strong
                      >
                    </td>
                    <td :class="['pl-0', 'text-muted', 'col']">
                      <div class="form-control" v-if="this.isDollar === 'BRL'">
                        {{
                          $utils.convertMoney(
                            versions_program_current.bounty_critical
                          )
                        }}
                      </div>
                      <div class="form-control" v-else>
                        {{
                          $utils.convertDollar(
                            versions_program_current.bounty_critical
                          )
                        }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- OUTRAS RECOMPENSAS -->
          <div
            v-if="menuItem === 'otherRewards'"
            class="d-flex justify-content-between"
            style="gap: 10px"
          >
            <!-- OUTRAS RECOMPENSAS - VERSÃO ANTIGA -->
            <div class="card card-body p-0 d-flex col">
              <table>
                <thead>
                  <tr>
                    <th class="col-16" v-text="$ml.get('reward')">
                      Recompensa
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(
                      item, index
                    ) in versions_program_old.optional_rewards"
                    :key="index"
                    :class="{
                      removeScope:
                        !versions_program_current.optional_rewards.find(
                          (itemCurrent) => itemCurrent === item
                        ),
                    }"
                  >
                    <td class="col-22" v-text="item"></td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- OUTRAS RECOMPENSAS - VERSÃO ATUAL -->
            <div class="card card-body p-0 d-flex col">
              <table>
                <thead>
                  <tr>
                    <th class="col-16" v-text="$ml.get('reward')">
                      Recompensa
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(
                      item, index
                    ) in versions_program_current.optional_rewards"
                    :key="index"
                    :class="{
                      addScope:
                        !versions_program_old?.optional_rewards.includes(item),
                    }"
                  >
                    <td class="col-22" v-text="item"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template #modal-footer="{ cancel }">
      <b-button
        class="float-right btn-outline-extra"
        size="sm"
        variant="primary"
        @click="$emit('close', cancel())"
      >
        {{ $ml.get("toClose") }}
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import { CodeDiff } from "v-code-diff";
export default {
  name: "VersionManagement",
  props: ["eventId", "programUpdates"],
  components: {
    CodeDiff,
  },
  data() {
    return {
      menuItem: "name",
      versions_program_old: [],
      versions_program_current: [],
      isDollar: "",
      filterListProgramUpdates: [],
      currentStep: null,
    };
  },

  mounted() {
    this.filterListProgramUpdates = this.programUpdates
      .filter((item) => item.current_version?._id && item.old_version?._id)
      .reverse();
    const findIndex = this.filterListProgramUpdates.findIndex(
      (item) => item._id === this.eventId
    );
    this.currentStep = findIndex;

    this.isDollar = this.$store.getters["getUser"]?.currency;
  },

  computed: {
    placeholderMoney() {
      return this.isDollar === "BRL" ? "R$ 0,00" : "$ 0,00";
    },
  },

  watch: {
    currentStep() {
      this.updateVersion(this.filterListProgramUpdates[this.currentStep]);
    },
  },
  methods: {
    updateVersion(data) {
      // VERSÃO ATUAL DO PROGRAMA
      const program_current_version = {
        ...data.current_version,
        bounty_low: Number(data.current_version.bounty_low),
        bounty_medium: Number(data.current_version.bounty_medium),
        bounty_high: Number(data.current_version.bounty_high),
        bounty_critical: Number(data.current_version.bounty_critical),
        scope: JSON.parse(data.current_version.scope).map((item) => item),
        optional_rewards: JSON.parse(data.current_version.optional_rewards).map(
          (item) => item
        ),
      };
      this.versions_program_current = program_current_version;

      // VERSÃO ANTIGA DO PROGRAMA
      const program_old_version = {
        ...data.old_version,
        bounty_low: Number(data.old_version.bounty_low),
        bounty_medium: Number(data.old_version.bounty_medium),
        bounty_high: Number(data.old_version.bounty_high),
        bounty_critical: Number(data.old_version.bounty_critical),
        scope: JSON.parse(data.old_version.scope).map((item) => item),
        optional_rewards: JSON.parse(data.old_version.optional_rewards).map(
          (item) => item
        ),
      };
      this.versions_program_old = program_old_version;
    },
    nameLang(name) {
      if (!["-"].includes(name) && name) {
        return this.$ml.get(name.replaceAll("-", ""));
      }
      return name;
    },
    mathAbsMoney(bounty) {
      this.versions_program_old[`${bounty}`] = Math.abs(
        this.versions_program_old[`${bounty}`]
      );
    },
  },
};
</script>
<style scoped>
.addScope {
  background: #e6ffec;
}
.removeScope {
  background: #ffebe9;
}
.remove-scope {
  position: absolute;
  border-top: 2px solid #e91e62c0;
  width: 100%;
  top: 50%;
  z-index: 1000;
}
.currency {
  position: absolute;
  left: 0px;
  top: -2.1px;
  transform: translate(6px, 67.7%);
  font-weight: 400;
  color: #495057;
}
.real {
  transform: translate(15px, 67.7%);
}
.container-version-manager {
  min-height: 455px;
  max-height: 455px;
  padding: 16px;
  overflow: auto;
}

.next-control {
  cursor: pointer;
  color: #730ba9;
  font-weight: 400;
}
</style>
